var _ellipse, _ellipse2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueSmileWithOutFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 24,
    fill: "none",
    viewBox: "0 0 28 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.27,
    cy: 3.411,
    fill: "#88C2C1",
    rx: 2.348,
    ry: 2.421
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.921,
    cy: 3.411,
    fill: "#88C2C1",
    rx: 2.348,
    ry: 2.421
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#88C2C1",
    d: "M14.094 23.99C4.51 23.99 1.326 15.865.84 11.275c-.04-.37.148-.725.494-.862 1.977-.784 6.538-1.248 12.76-1.248 6.216 0 10.987.463 13.104 1.245.371.137.573.516.519.907-.636 4.597-4.068 12.673-13.623 12.673z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSmileWithOutFace);
export default __webpack_public_path__ + "static/media/blue-smile-with-out-face.5faebe299d3be9869848eb6b93b00b12.svg";
export { ForwardRef as ReactComponent };